// URL в кавычках и с экранированием: адрес фото с `)` / пробелом / кавычкой
// иначе ломает css-функцию url() (фото пропадало), а значение из API не
// должно уметь дописывать произвольный CSS в style.
export function cssUrl(raw: string): string {
  return `url("${raw.replace(/["\\\n\r]/g, (ch) => encodeURIComponent(ch))}")`;
}
